// extracted by mini-css-extract-plugin
export default {"header":"ConfigPanel_header__Oz2MZ","button":"ConfigPanel_button__Gnx6c","selector":"ConfigPanel_selector__kAZkI"};